import React, { createContext, useContext, useEffect, useState } from "react";
import { adminLogin, adminMe } from "../lib/api";

const AdminAuthContext = createContext();
export const useAdminAuth = () => useContext(AdminAuthContext);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("fp_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    adminMe()
      .then(setAdmin)
      .catch(() => localStorage.removeItem("fp_admin_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { token, user } = await adminLogin({ email, password });
    localStorage.setItem("fp_admin_token", token);
    setAdmin(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem("fp_admin_token");
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}
